import { render, staticRenderFns } from "./managementPlanTemplate.vue?vue&type=template&id=2bad2db4&scoped=true&"
import script from "./managementPlanTemplate.vue?vue&type=script&lang=js&"
export * from "./managementPlanTemplate.vue?vue&type=script&lang=js&"
import style0 from "./managementPlanTemplate.vue?vue&type=style&index=0&id=2bad2db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad2db4",
  null
  
)

export default component.exports